import { createFileRoute, Navigate } from '@tanstack/react-router';
import { LoginForm } from '#features/auth/components/login-form';
import { ContinueWithVitto } from '#features/auth/vitto/continue-with-vitto';
import { useAuth } from '#features/auth/auth-context';
import { CircleCheck, ArrowUpRight } from 'lucide-react';

const LoginPage = () => {
  const { state } = useAuth();
  if (state === 'unknown')
    return (
      <main className="tasks-login">
        <p role="status">Connecting to Tasks…</p>
      </main>
    );
  if (state === 'authenticated') return <Navigate to="/" replace />;

  return (
    <main className="tasks-login">
      <section className="tasks-login-card" aria-labelledby="tasks-login-title">
        <div className="tasks-login-brand">
          <span className="tasks-login-mark">
            <CircleCheck aria-hidden="true" />
          </span>
          <span>Tasks</span>
        </div>
        <p className="tasks-login-eyebrow">LESS NOISE. MORE PROGRESS.</p>
        <h1 id="tasks-login-title">Good work starts here.</h1>
        <p className="tasks-login-description">
          A clear place for everything your team is moving forward.
        </p>
        <div className="tasks-login-divider">
          <span>Sign in to your workspace</span>
          <ArrowUpRight aria-hidden="true" />
        </div>
        <LoginForm />
        {/* only in a top-level tab of a deploy that knows its Vitto; nothing renders otherwise */}
        <ContinueWithVitto className="mt-4 w-full" />
        <p className="tasks-login-footnote">
          Your tasks, conversations and next steps. All in one place.
        </p>
      </section>
    </main>
  );
};

export const Route = createFileRoute('/login')({ component: LoginPage });
